module.exports = __webpack_public_path__ + "static/media/icon-option-grey.76cccdcc.png";